module.exports = __webpack_public_path__ + "static/img/news3.a3033cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news3/news3.jpg
// module id = 4cfg
// module chunks = 1